import { CHART_REGISTRY } from './chart-registry';
import { wrapChart } from './lib/share-capture';

/**
 * Chart components with the `withShareCapture` HOC applied. Every entry in
 * `CHART_REGISTRY` gets a corresponding wrapped export here — one line each.
 * Call-site signatures (including generics) are preserved via `wrapChart`.
 *
 * Adding a new replots chart: add an import + entry to `chart-registry.ts`
 * and a single line below.
 */
export const AreaChart = wrapChart(CHART_REGISTRY.AreaChart, 'AreaChart');
export const BarChart = wrapChart(CHART_REGISTRY.BarChart, 'BarChart');
export const BoxPlot = wrapChart(CHART_REGISTRY.BoxPlot, 'BoxPlot');
export const DivergingBarChart = wrapChart(
  CHART_REGISTRY.DivergingBarChart,
  'DivergingBarChart'
);
export const DivergingBarWithArrows = wrapChart(
  CHART_REGISTRY.DivergingBarWithArrows,
  'DivergingBarWithArrows'
);
export const GaugeChart = wrapChart(CHART_REGISTRY.GaugeChart, 'GaugeChart');
export const GroupedBarChart = wrapChart(
  CHART_REGISTRY.GroupedBarChart,
  'GroupedBarChart'
);
export const LineChart = wrapChart(CHART_REGISTRY.LineChart, 'LineChart');
export const PieChart = wrapChart(CHART_REGISTRY.PieChart, 'PieChart');
export const SankeyChart = wrapChart(CHART_REGISTRY.SankeyChart, 'SankeyChart');
export const SingleMetricChart = wrapChart(
  CHART_REGISTRY.SingleMetric,
  'SingleMetric'
);
export const StackedBarChartHorizontal = wrapChart(
  CHART_REGISTRY.StackedBarChartHorizontal,
  'StackedBarChartHorizontal'
);
export const TableChart = wrapChart(CHART_REGISTRY.TableChart, 'TableChart');
export const TreeMap = wrapChart(CHART_REGISTRY.TreeMap, 'TreeMap');
export const VolumeChart = wrapChart(CHART_REGISTRY.VolumeChart, 'VolumeChart');

// Types from each chart component file (the components themselves are
// re-exported with the share-capture HOC applied above).
export type * from './lib/components/area/area-chart';
export type * from './lib/components/bar/bar-chart';
export type * from './lib/components/box/box-plot';
export type * from './lib/components/diverging-bar/diverging-bar-chart';
// Non-component runtime export that lives in a chart file.
export { DIVERGING_BAR_HEADER_LABEL_HEIGHT } from './lib/components/diverging-bar/diverging-bar-chart';
export type * from './lib/components/diverging-bar/diverging-bar-with-arrows';
export type * from './lib/components/gauge/gauge-chart';
export type * from './lib/components/grouped-bar/grouped-bar-chart';
export type * from './lib/components/line/line-chart';
export type * from './lib/components/pie/pie-chart';
export type * from './lib/components/sankey/sankey-chart';
export type * from './lib/components/single-metric/single-metric-chart';
export type * from './lib/components/stacked-bar/stacked-bar-chart-horizontal';
export type * from './lib/components/table/table-chart';
export type * from './lib/components/treemap/treemap';
export type * from './lib/components/volume/volume-chart';
